<template>
	<Popup
		v-model="selfDisplay"
		title="充值卡充值"
		confirmBtnText="确认"
		@confirmClick="handleConfirmClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>卡号</span>
				<el-input v-model="number" placeholder="卡号"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="number_tip"><i class="b_icon"></i>请输入卡号</template></div>
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>密码</span>
				<el-input v-model="password" type="password" placeholder="密码"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="password_tip"><i class="b_icon"></i>请输入密码</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../api/index.js';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			id: {
				type: String,
				default: ''
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				selfDisplay: false,
				loading: false,
				number: '',
				number_tip: false,
				password: '',
				password_tip: false
			}
		},
		methods: {
			// 点击确认
			handleConfirmClick() {
				const that = this;
				if (!that.number.trim()) {
					that.number_tip = true;
					return false;
				} else {
					that.number_tip = false;
				}
				if (!that.password.trim()) {
					that.password_tip = true;
					return false;
				} else {
					that.password_tip = false;
				}
				that.loading = true;
				let requestData = {
					cardNo: that.number,
					cardPwd: that.password,
					wuserId: that.id
				};
				Api.activeCard(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.$message.success(res.data.message);
						that.selfDisplay = false;
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newValue) {
				this.selfDisplay = newValue;
			},
			selfDisplay(newValue) {
				this.$emit('changeDisplay', newValue);
				if (!newValue) {
					this.loading = false;
					this.number = '';
					this.number_tip = false;
					this.password = '';
					this.password_tip = false;
				}
			}
		}
	}
</script>

<style>
</style>
